/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgParenthesis = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6.22 2.373c-4.294 5.337-4.294 13.917 0 19.254l1.56-1.254c-3.706-4.605-3.706-12.142 0-16.746zm10 1.254c3.706 4.604 3.706 12.142 0 16.746l1.56 1.254c4.294-5.337 4.294-13.917 0-19.254z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgParenthesis as Parenthesis };
